/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Gotonextpage3Inputs */

const he_common_gotonextpage3 = /** @type {(inputs: Common_Gotonextpage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עבור לעמוד הבא`)
};

const en_common_gotonextpage3 = /** @type {(inputs: Common_Gotonextpage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to next page`)
};

/**
* | output |
* | --- |
* | "Go to next page" |
*
* @param {Common_Gotonextpage3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_gotonextpage3 = /** @type {((inputs?: Common_Gotonextpage3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Gotonextpage3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_gotonextpage3(inputs)
	return en_common_gotonextpage3(inputs)
});
export { common_gotonextpage3 as "common_goToNextPage" }